"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexContainer = exports.SwapIcon = exports.SwapContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _Icon = _interopRequireDefault(require("../Icon"));

var _transitions = require("../../utils/transitions");

var _mediaQueries = _interopRequireDefault(require("../../utils/media-queries"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      opacity: 1;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var fadeGradient = function fadeGradient(_ref) {
  var theme = _ref.theme;
  return (
    /* eslint-disable prefer-template */
    'linear-gradient(' + '180deg, ' + (0, _polished.transparentize)(1, theme.color.background) + ' 0%, ' + theme.color.background + ' 15%, ' + theme.color.background + ' 85%, ' + (0, _polished.transparentize)(1, theme.color.background) + ' 100%' + ')'
  );
};

var SwapContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__SwapContainer",
  componentId: "bjbxk9-0"
})(["position:relative;align-self:stretch;width:0;cursor:pointer;.icon-inherit-color{fill:", ";}&:hover .icon-inherit-color{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.miscDark;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.primary;
});

exports.SwapContainer = SwapContainer;
var SwapIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styled__SwapIcon",
  componentId: "bjbxk9-1"
})(["box-sizing:content-box;width:15px;padding:5px 0;position:absolute;left:-7.5px;top:50%;margin-top:-12.5px;z-index:3;transfrom:translateZ(0);background:", ";"], function (props) {
  return fadeGradient(props);
});
exports.SwapIcon = SwapIcon;

var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__FlexContainer",
  componentId: "bjbxk9-2"
})(["display:flex;", "{opacity:0;", " ", "}&:hover ", "{opacity:1;transition-delay:.15s;}"], SwapIcon, _transitions.switchTransition, _mediaQueries["default"].handheld(_templateObject()), SwapIcon);

exports.FlexContainer = FlexContainer;